/**
 * Phase 69 Plan 05 — minimal AccessDeniedPage.
 *
 * Rendered as the <Can> fallback at the /admin/users route when a user
 * lacks the admin_users:manage permission (operator / viewer / admin
 * by default — UI-SPEC §7).
 *
 * Intentionally minimal — no toast, no redirect (Marco can navigate back
 * via the sidebar). Carries a stable data-testid so e2e tests can assert
 * the fallback fired.
 */
import { useTranslation } from "react-i18next";
import { AlertTriangle } from "lucide-react";

import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";

export default function AccessDeniedPage() {
  const { t } = useTranslation();
  return (
    <section
      data-testid="access-denied-page"
      className="p-8 max-w-xl mx-auto"
      aria-labelledby="access-denied-h2"
    >
      <Alert variant="destructive">
        <AlertTriangle aria-hidden="true" />
        <AlertTitle id="access-denied-h2">
          {t("common.accessDenied.title", "Accesso negato")}
        </AlertTitle>
        <AlertDescription>
          {t(
            "admin.users.error.denied",
            "Non hai i permessi per accedere a questa pagina.",
          )}
        </AlertDescription>
      </Alert>
    </section>
  );
}
